
import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({
  name: 'OpenStorePop',
})
export default class OpenStorePop extends Vue {
  showResult = false;

  created() {}

  showPopup() {
    this.showResult = true
  }

  onCancel() {
    this.showResult = false
  }

  onOpen() {
    this.showResult = false
    this.$router.push('/newCCXstore');
  }
}
